<span class="page-input">
    <label title="{{tooltip}}" #inputLabel>{{ placeholder }}</label>
    <ng-content> 
    </ng-content>
</span> 

